var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description",class:{ new: _vm.$route.meta.isNews },domProps:{"innerHTML":_vm._s(_vm.info.description)}})
}
var staticRenderFns = []

export { render, staticRenderFns }